module.exports = __webpack_public_path__ + "static/Artboard-13-efaa570219dc1ff452601f5e7be7d59e.png";